import { Box, Card, CardContent, Grid, Skeleton } from '@mui/material';

const SkeletonCard: React.FC = () => (
  <Card variant='ghost' color='primary' sx={{ height: '100%' }}>
    <CardContent sx={{ display: 'flex', flexDirection: 'column', p: 2.5, height: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <Skeleton variant='circular' width={50} height={50} />
      </Box>
      <Box sx={{ flex: 1 }} display='flex' justifyContent='space-between' alignItems='flex-end'>
        <Box sx={{ minWidth: 0, flex: 1, mr: 2, mt: 0.4 }}>
          <Skeleton variant='text' width='80%' sx={{ maxWidth: '180px' }} height={35} />
          <Skeleton variant='text' width='95%' sx={{ maxWidth: '230px' }} height={28} />
        </Box>
        <Skeleton variant='rounded' width={120} height={50} sx={{ flexShrink: 0 }} />
      </Box>
    </CardContent>
  </Card>
);

const AdminSettingsCardSkeleton: React.FC = () => (
  <Grid container spacing={{ xs: 3, lg: 4, xl: 6 }}>
    <Grid size={{ xs: 12, md: 6 }}>
      <SkeletonCard />
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <SkeletonCard />
    </Grid>
  </Grid>
);

export default AdminSettingsCardSkeleton;
